import { createSlice, Dispatch } from "@reduxjs/toolkit";
import CountriesService, { RouteByCountryItem } from "../actions/airports.service";

interface CountriesState {
  // existing usage in your app (airports)
  countries: Array<any>;

  // NEW: destinations menu data
  routesByCountry: RouteByCountryItem[];

  // optional flags
  loadingAirports: boolean;
  loadingRoutes: boolean;
  error?: string | null;
}

const initialState: CountriesState = {
  countries: [],
  routesByCountry: [],
  loadingAirports: false,
  loadingRoutes: false,
  error: null,
};

export const fetchAirports = () => async (dispatch: Dispatch) => {
  dispatch(setLoadingAirports(true));
  dispatch(setError(null));

  try {
    const response = await CountriesService.getAirports();
    dispatch(setCountries(response));
  } catch (e: any) {
    dispatch(setError(e?.message || "Failed to fetch airports"));
  } finally {
    dispatch(setLoadingAirports(false));
  }
};

export const fetchRoutesByCountry = () => async (dispatch: Dispatch) => {
  dispatch(setLoadingRoutes(true));
  dispatch(setError(null));

  try {
    const response = await CountriesService.getRoutesByCountry();
    dispatch(setRoutesByCountry(Array.isArray(response) ? response : []));
  } catch (e: any) {
    dispatch(setError(e?.message || "Failed to fetch routes by country"));
  } finally {
    dispatch(setLoadingRoutes(false));
  }
};

const stateSlice = createSlice({
  name: "home/countries",
  initialState,
  reducers: {
    setCountries: (state, action) => {
      state.countries = action.payload;
    },

    setRoutesByCountry: (state, action) => {
      state.routesByCountry = action.payload;
    },

    setLoadingAirports: (state, action) => {
      state.loadingAirports = Boolean(action.payload);
    },

    setLoadingRoutes: (state, action) => {
      state.loadingRoutes = Boolean(action.payload);
    },

    setError: (state, action) => {
      state.error = action.payload ?? null;
    },
  },
});

export const {
  setCountries,
  setRoutesByCountry,
  setLoadingAirports,
  setLoadingRoutes,
  setError,
} = stateSlice.actions;

export default stateSlice.reducer;
